import { useQuery } from '@tanstack/react-query';
import { fetchApi } from '@/std/api/fetchApi';
import { registrosSchema } from '@/std/schema';
import { ProdutoTipoFiscalSchema } from '../types/ProdutoTipoFiscal';

type ApiProdutoTipoParams = {
    pesquisar?: string;
};

const schema = registrosSchema(ProdutoTipoFiscalSchema);

function apiProdutoTipo(params?: ApiProdutoTipoParams) {
    return fetchApi({
        endpoint: 'ProdutoTipo/ProdutoTipo',
        method: 'get',
        params,
        schema,
    });
}

export function useProdutoTipoQuery(params?: ApiProdutoTipoParams) {
    return useQuery({
        queryFn: () => apiProdutoTipo(params),
        queryKey: ['apiProdutoTipo', params],
    });
}
